import React, { Component, Suspense } from 'react';
import Loader from './Loader';

// ==============================|| ERROR BOUNDARY - CHUNK LOAD FAILURE ||============================== //

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Loadable Error Boundary caught an error:', error, errorInfo);
    
    const errorMessage = error?.message || error?.toString() || '';
    const errorStack = error?.stack || '';
    
    if (
      errorMessage.includes('Failed to fetch dynamically imported module') ||
      errorMessage.includes('Loading chunk') ||
      errorStack.includes('Failed to fetch dynamically imported module') ||
      errorStack.includes('Loading chunk')
    ) {
      const reloadKey = 'chunk-failed-reload';
      const lastReload = sessionStorage.getItem(reloadKey);
      const now = Date.now();

      // Only reload if we haven't reloaded in the last 10 seconds to avoid infinite loops
      if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
        sessionStorage.setItem(reloadKey, now.toString());
        console.warn('Chunk loading failed. Reloading page to fetch the latest assets...', errorMessage);
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return <Loader />;
    }
    return this.props.children;
  }
}

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (ComponentToLoad) => (props) => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <ComponentToLoad {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default Loadable;
